/**
 * Validate organisation number that only allow 9 digits
 * @param orgNr
 * @returns True for valie org number, false for invalid
 */
const validateOrganisationNo = (orgNr: string) => {
  const regexp = new RegExp(/^\d{9}$/);

  return regexp.test(orgNr);
};

export default validateOrganisationNo;
